import { useEffect, useRef } from 'preact/hooks';
import { playSound } from '../../audio/sounds.js';
import type { TurnClockState } from '../../../shared/arena/turnClock.js';

/** Soft beeps start when this much normal turn time is left (user request 2026-09-27). */
const TURN_TICK_FROM_MS = 5000;

/**
 * Countdown beeps on the player's own turn: a soft beep every second during the last five
 * seconds of the normal turn time, and a different beep every second while the time bank runs.
 */
export function useTurnTicks(clock: TurnClockState | null, myTurn: boolean): void {
  let key: string | null = null;
  if (clock && myTurn) {
    if (clock.phase === 'turn' && clock.turnRemainingMs <= TURN_TICK_FROM_MS) {
      key = `turn:${Math.ceil(clock.turnRemainingMs / 1000)}`;
    } else if (clock.phase === 'bank') {
      key = `bank:${Math.ceil(clock.bankRemainingMs / 1000)}`;
    }
  }
  const last = useRef<string | null>(null);
  useEffect(() => {
    if (key && key !== last.current) playSound(key.startsWith('bank') ? 'bankTick' : 'turnTick');
    last.current = key;
  }, [key]);
}
